import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ACIHighwayTranslationProvider from '../contexts/ACIHighwayTranslationContext.js'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ACIHighwayTranslationProvider>
          <TablePage showNotification={showSnackbar} {...props} />
        </ACIHighwayTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ACIHighwayTranslationProvider>
          <AddPage showNotification={showSnackbar} {...props} />
        </ACIHighwayTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ACIHighwayTranslationProvider>
          <EditPage showNotification={showSnackbar} {...props} />
        </ACIHighwayTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ACIHighwayTranslationProvider>
          <ViewPage showNotification={showSnackbar} {...props} />
        </ACIHighwayTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}



export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
